// extracted by mini-css-extract-plugin
module.exports = {"brand":"Brand_brand__34jgu"};